import { ButtonProps } from 'antd/lib/button';

import { UiButton } from '../ui-button';

type Props = {
  onClick: () => void;
} & ButtonProps;

export function UiCancelButton(props: Props) {
  return (
    <UiButton
      {...props}
      htmlType="button"
      type="default"
      onClick={props.onClick}
    >
      Отмена
    </UiButton>
  );
}
